import { ReactComponent as AccountSettings } from '../../icons/content/account-settings.svg';
import { ReactComponent as CheckmarkBig } from '../../icons/content/checkmark-big.svg';
import { ReactComponent as EnhanceFormulation } from '../../icons/content/enhance-formulation.svg';
import { ReactComponent as FineChemicals } from '../../icons/content/fine-chemicals.svg';
import { ReactComponent as FixFormulation } from '../../icons/content/fix-formulation.svg';
import { ReactComponent as OrderHistory } from '../../icons/content/order-history.svg';
import { ReactComponent as SendBriefing } from '../../icons/content/send-briefing.svg';

export const contentIcons = {
  FineChemicals,
  OrderHistory,
  AccountSettings,
  FixFormulation,
  EnhanceFormulation,
  SendBriefing,
  CheckmarkBig,
};
